import NODE10 from "@/statics/devices/Node10/header.js";
import NODE11 from "@/statics/devices/Node11/header.js";
import NODE13 from "@/statics/devices/Node13/header.js";
import NODE14 from "@/statics/devices/Node14/header.js";
import NODE15 from "@/statics/devices/Node15/header.js";
import NODE16 from "@/statics/devices/Node16/header.js";
import NODE17 from "@/statics/devices/Node17/header.js";
import NODE18 from "@/statics/devices/Node18/header.js";
import NODE2 from "@/statics/devices/Node2/header.js";
import NODE3 from "@/statics/devices/Node3/header.js";
import NODE4 from "@/statics/devices/Node4/header.js";
import NODE5 from "@/statics/devices/Node5/header.js";
import NODE6 from "@/statics/devices/Node6/header.js";
import NODE7 from "@/statics/devices/Node7/header.js";
import NODE9 from "@/statics/devices/Node9/header.js";

const NODES_ADD_ACTIONS = {
  addNode2: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE2.INPUT1.TYPE,
          name: store.getters.language.texts[NODE2.INPUT1.NAME],
          icon: NODE2.INPUT1.ICON,
          parameterId: NODE2.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE2.INPUT2.TYPE,
          name: store.getters.language.texts[NODE2.INPUT2.NAME],
          icon: NODE2.INPUT2.ICON,
          parameterId: NODE2.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE2.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT1.NAME],
          icon: NODE2.OUTPUT1.ICON,
          parameterId: NODE2.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE2.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE2.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE2.OUTPUT2.NAME],
          icon: NODE2.OUTPUT2.ICON,
          parameterId: NODE2.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE2.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name + "-1",
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
      store.commit("addWidget", {
        name: nodeContex.name + "-2",
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 1,
        },
      });
    }
  },
  addNode3: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE3.INPUT1.TYPE,
          name: store.getters.language.texts[NODE3.INPUT1.NAME],
          icon: NODE3.INPUT1.ICON,
          parameterId: NODE3.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE3.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE3.OUTPUT1.NAME],
          icon: NODE3.OUTPUT1.ICON,
          parameterId: NODE3.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE3.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name,
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode4: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE4.INPUT1.TYPE,
          name: store.getters.language.texts[NODE4.INPUT1.NAME],
          icon: NODE4.INPUT1.ICON,
          parameterId: NODE4.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE4.INPUT2.TYPE,
          name: store.getters.language.texts[NODE4.INPUT2.NAME],
          icon: NODE4.INPUT2.ICON,
          parameterId: NODE4.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE4.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE4.OUTPUT1.NAME],
          icon: NODE4.OUTPUT1.ICON,
          parameterId: NODE4.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE4.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name,
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode5: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE5.INPUT1.TYPE,
          name: store.getters.language.texts[NODE5.INPUT1.NAME],
          icon: NODE5.INPUT1.ICON,
          parameterId: NODE5.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE5.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE5.OUTPUT1.NAME],
          icon: NODE5.OUTPUT1.ICON,
          parameterId: NODE5.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE5.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name,
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode6: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE6.INPUT1.TYPE,
          name: store.getters.language.texts[NODE6.INPUT1.NAME],
          icon: NODE6.INPUT1.ICON,
          parameterId: NODE6.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE6.INPUT2.TYPE,
          name: store.getters.language.texts[NODE6.INPUT2.NAME],
          icon: NODE6.INPUT2.ICON,
          parameterId: NODE6.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [],
    });
  },
  addNode7: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE7.INPUT1.TYPE,
          name: store.getters.language.texts[NODE7.INPUT1.NAME],
          icon: NODE7.INPUT1.ICON,
          parameterId: NODE7.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE7.INPUT2.TYPE,
          name: store.getters.language.texts[NODE7.INPUT2.NAME],
          icon: NODE7.INPUT2.ICON,
          parameterId: NODE7.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [],
    });
  },
  addNode8: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE7.INPUT1.TYPE,
          name: store.getters.language.texts[NODE7.INPUT1.NAME],
          icon: NODE7.INPUT1.ICON,
          parameterId: NODE7.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE7.INPUT2.TYPE,
          name: store.getters.language.texts[NODE7.INPUT2.NAME],
          icon: NODE7.INPUT2.ICON,
          parameterId: NODE7.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [],
    });
  },
  addNode9: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE9.INPUT1.TYPE,
          name: store.getters.language.texts[NODE9.INPUT1.NAME],
          icon: NODE9.INPUT1.ICON,
          parameterId: NODE9.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE9.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE9.OUTPUT1.NAME],
          icon: NODE9.OUTPUT1.ICON,
          parameterId: NODE9.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE9.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE9.OUTPUT2.NAME],
          icon: NODE9.OUTPUT2.ICON,
          parameterId: NODE9.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE9.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE9.OUTPUT3.NAME],
          icon: NODE9.OUTPUT3.ICON,
          parameterId: NODE9.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE9.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE9.OUTPUT4.NAME],
          icon: NODE9.OUTPUT4.ICON,
          parameterId: NODE9.OUTPUT4.PARAMETER_ID,
          initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE9.OUTPUT5.TYPE,
          name: store.getters.language.texts[NODE9.OUTPUT5.NAME],
          icon: NODE9.OUTPUT5.ICON,
          parameterId: NODE9.OUTPUT5.PARAMETER_ID,
          initialStateParameterId: NODE9.RGBW_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
  },
  addNode10: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [],
      outputs: [
        {
          type: NODE10.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE10.OUTPUT1.NAME],
          icon: NODE10.OUTPUT1.ICON,
          parameterId: NODE10.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE10.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE10.OUTPUT2.NAME],
          icon: NODE10.OUTPUT2.ICON,
          parameterId: NODE10.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE10.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE10.OUTPUT3.NAME],
          icon: NODE10.OUTPUT3.ICON,
          parameterId: NODE10.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE10.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE10.OUTPUT4.NAME],
          icon: NODE10.OUTPUT4.ICON,
          parameterId: NODE10.OUTPUT4.PARAMETER_ID,
          initialStateParameterId: NODE10.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
  },
  addNode11: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE11.INPUT1.TYPE,
          name: store.getters.language.texts[NODE11.INPUT1.NAME],
          icon: NODE11.INPUT1.ICON,
          parameterId: NODE11.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE11.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT1.NAME],
          icon: NODE11.OUTPUT1.ICON,
          parameterId: NODE11.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE11.RELAY_INIT_CONFIG.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE11.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT2.NAME],
          icon: NODE11.OUTPUT2.ICON,
          parameterId: NODE11.OUTPUT2.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE11.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT3.NAME],
          icon: NODE11.OUTPUT3.ICON,
          parameterId: NODE11.OUTPUT3.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE11.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT4.NAME],
          icon: NODE11.OUTPUT4.ICON,
          parameterId: NODE11.OUTPUT4.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE11.OUTPUT5.TYPE,
          name: store.getters.language.texts[NODE11.OUTPUT5.NAME],
          icon: NODE11.OUTPUT5.ICON,
          parameterId: NODE11.OUTPUT5.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name + "-1",
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode13: function (store, nodeContex) {
    store.commit("addNode", {
      name: "RGB",
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [],
      outputs: [
        {
          type: NODE13.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT1.NAME],
          icon: NODE13.OUTPUT1.ICON,
          parameterId: NODE13.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE13.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT2.NAME],
          icon: NODE13.OUTPUT2.ICON,
          parameterId: NODE13.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE13.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT3.NAME],
          icon: NODE13.OUTPUT3.ICON,
          parameterId: NODE13.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE13.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE13.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE13.OUTPUT4.NAME],
          icon: NODE13.OUTPUT4.ICON,
          parameterId: NODE13.OUTPUT4.PARAMETER_ID,
          initialStateParameterId: NODE13.RGB_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    store.commit("addWidget", {
      name: "RGB",
      color: nodeContex.color,
      type: "rgbwWidget",
      hubUUID: nodeContex.hubUUID,
      nodeUUIDs: [nodeContex.uuid],
      visible: true,
      settings: {
        outputIndex: 0,
        paletteType: 0,
      },
    });
  },
  addNode14: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE14.INPUT1.TYPE,
          name: store.getters.language.texts[NODE14.INPUT1.NAME],
          icon: NODE14.INPUT1.ICON,
          parameterId: NODE14.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE14.INPUT2.TYPE,
          name: store.getters.language.texts[NODE14.INPUT2.NAME],
          icon: NODE14.INPUT2.ICON,
          parameterId: NODE14.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE14.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE14.OUTPUT1.NAME],
          icon: NODE14.OUTPUT1.ICON,
          parameterId: NODE14.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE14.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    // TODO: check here if the switch widget needs to be changed
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name,
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
    }
  },
  addNode15: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE15.INPUT1.TYPE,
          name: store.getters.language.texts[NODE15.INPUT1.NAME],
          icon: NODE15.INPUT1.ICON,
          parameterId: NODE15.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        }
      ],
      outputs: [
        {
          type: NODE15.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE15.OUTPUT1.NAME],
          icon: NODE15.OUTPUT1.ICON,
          parameterId: NODE15.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE15.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        }
      ],
    });
    if (nodeContex.isPaired) {
      store.commit("addWidget", {
        name: nodeContex.name + "-1",
        color: nodeContex.color,
        type: "singleSwitchWidget",
        hubUUID: nodeContex.hubUUID,
        nodeUUIDs: [nodeContex.uuid],
        visible: true,
        settings: {
          outputIndex: 0,
        },
      });
     
    }
  },
  addNode16: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE16.INPUT1.TYPE,
          name: store.getters.language.texts[NODE16.INPUT1.NAME],
          icon: NODE16.INPUT1.ICON,
          parameterId: NODE16.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE16.INPUT2.TYPE,
          name: store.getters.language.texts[NODE16.INPUT2.NAME],
          icon: NODE16.INPUT2.ICON,
          parameterId: NODE16.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE16.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE16.OUTPUT1.NAME],
          icon: NODE16.OUTPUT1.ICON,
          parameterId: NODE16.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE16.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE16.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE16.OUTPUT2.NAME],
          icon: NODE16.OUTPUT2.ICON,
          parameterId: NODE16.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE16.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      for (let i = 0; i < 2; i++) {
        store.commit("addWidget", {
          name: nodeContex.name + `-${i + 1}`,
          color: nodeContex.color,
          type: "singleSwitchWidget",
          hubUUID: nodeContex.hubUUID,
          nodeUUIDs: [nodeContex.uuid],
          visible: true,
          settings: {
            outputIndex: i,
          },
        });
      }
    }
  },
  addNode18: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE18.INPUT1.TYPE,
          name: store.getters.language.texts[NODE18.INPUT1.NAME],
          icon: NODE18.INPUT1.ICON,
          parameterId: NODE18.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE18.INPUT2.TYPE,
          name: store.getters.language.texts[NODE18.INPUT2.NAME],
          icon: NODE18.INPUT2.ICON,
          parameterId: NODE18.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE18.INPUT3.TYPE,
          name: store.getters.language.texts[NODE18.INPUT3.NAME],
          icon: NODE18.INPUT3.ICON,
          parameterId: NODE18.INPUT3.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE18.INPUT4.TYPE,
          name: store.getters.language.texts[NODE18.INPUT4.NAME],
          icon: NODE18.INPUT4.ICON,
          parameterId: NODE18.INPUT4.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
      ],
      outputs: [
        {
          type: NODE18.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE18.OUTPUT1.NAME],
          icon: NODE18.OUTPUT1.ICON,
          parameterId: NODE18.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE18.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE18.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE18.OUTPUT2.NAME],
          icon: NODE18.OUTPUT2.ICON,
          parameterId: NODE18.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE18.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE18.OUTPUT3.NAME],
          icon: NODE18.OUTPUT3.ICON,
          parameterId: NODE18.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE18.OUTPUT4.TYPE,
          name: store.getters.language.texts[NODE18.OUTPUT4.NAME],
          icon: NODE18.OUTPUT4.ICON,
          parameterId: NODE18.OUTPUT4.PARAMETER_ID,
          initialStateParameterId: NODE18.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
      ],
    });
    if (nodeContex.isPaired) {
      for (let i = 0; i < 4; i++) {
        store.commit("addWidget", {
          name: nodeContex.name + `-${i + 1}`,
          color: nodeContex.color,
          type: "singleSwitchWidget",
          hubUUID: nodeContex.hubUUID,
          nodeUUIDs: [nodeContex.uuid],
          visible: true,
          settings: {
            outputIndex: i,
          },
        });
      }
    }
  },
  addNode17: function (store, nodeContex) {
    store.commit("addNode", {
      name: nodeContex.name,
      color: nodeContex.color,
      uuid: nodeContex.uuid,
      hubUUID: nodeContex.hubUUID,
      deviceType: nodeContex.deviceType,
      firmwareYear: nodeContex.firmwareYear,
      firmwareMonth: nodeContex.firmwareMonth,
      isPaired: nodeContex.isPaired,
      connectionStatus: -1,
      rawParameters: [],
      inputs: [
        {
          type: NODE17.INPUT1.TYPE,
          name: store.getters.language.texts[NODE17.INPUT1.NAME],
          icon: NODE17.INPUT1.ICON,
          parameterId: NODE17.INPUT1.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE17.INPUT2.TYPE,
          name: store.getters.language.texts[NODE17.INPUT2.NAME],
          icon: NODE17.INPUT2.ICON,
          parameterId: NODE17.INPUT2.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        },
        {
          type: NODE17.INPUT3.TYPE,
          name: store.getters.language.texts[NODE17.INPUT3.NAME],
          icon: NODE17.INPUT3.ICON,
          parameterId: NODE17.INPUT3.PARAMETER_ID,
          settings: {
            inputType: 0,
          },
        }
      ],
      outputs: [
        {
          type: NODE17.OUTPUT1.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT1.NAME],
          icon: NODE17.OUTPUT1.ICON,
          parameterId: NODE17.OUTPUT1.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY1_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE17.OUTPUT2.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT2.NAME],
          icon: NODE17.OUTPUT2.ICON,
          parameterId: NODE17.OUTPUT2.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        },
        {
          type: NODE17.OUTPUT3.TYPE,
          name: store.getters.language.texts[NODE17.OUTPUT3.NAME],
          icon: NODE17.OUTPUT3.ICON,
          parameterId: NODE17.OUTPUT3.PARAMETER_ID,
          initialStateParameterId: NODE17.RELAY2_INIT.PARAMETER_ID,
          settings: {
            outputType: 0,
          },
        }
      ],
    });
    if (nodeContex.isPaired) {
      for (let i = 0; i < 3; i++) {
        store.commit("addWidget", {
          name: nodeContex.name + `-${i + 1}`,
          color: nodeContex.color,
          type: "singleSwitchWidget",
          hubUUID: nodeContex.hubUUID,
          nodeUUIDs: [nodeContex.uuid],
          visible: true,
          settings: {
            outputIndex: i,
          },
        });
      }
    }
  },
};
export default NODES_ADD_ACTIONS;
